/**
 * @generated SignedSource<<0c03fc872ffd46bc11d16e671b796945>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EmailLinkTrackerMutation$variables = {
  newsletterId: string;
  unsubscribe?: boolean | null;
};
export type EmailLinkTrackerMutation$data = {
  readonly trackEmailLinkClick: boolean;
};
export type EmailLinkTrackerMutation = {
  response: EmailLinkTrackerMutation$data;
  variables: EmailLinkTrackerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "newsletterId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "unsubscribe"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "newsletterId",
        "variableName": "newsletterId"
      },
      {
        "kind": "Variable",
        "name": "unsubscribe",
        "variableName": "unsubscribe"
      }
    ],
    "kind": "ScalarField",
    "name": "trackEmailLinkClick",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailLinkTrackerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailLinkTrackerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "40a6ede68e68a2d6794468d18c4deb64",
    "id": null,
    "metadata": {},
    "name": "EmailLinkTrackerMutation",
    "operationKind": "mutation",
    "text": "mutation EmailLinkTrackerMutation(\n  $newsletterId: String!\n  $unsubscribe: Boolean\n) {\n  trackEmailLinkClick(newsletterId: $newsletterId, unsubscribe: $unsubscribe)\n}\n"
  }
};
})();

(node as any).hash = "1684cca7c81105c6c46f77ee0c7c727d";

export default node;
